import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export interface CollectionMethod {
  method: string;
  price: number;
}

export const useCreateClinicCollectionMethod = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (collectionMethod: CollectionMethod) => {
      return api.post("clinic/collection-methods", {
        collection_method: collectionMethod.method,
        collection_price: collectionMethod.price,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "create-collection-method-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Clinic Collection Method]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.collectionMethods(),
      });

      handleErrors(res, "mutation");
    },
  });
};
